module.exports = __webpack_public_path__ + "img/zsplus.faa52687.png";